type BrandsType = {
  icon: string;
  name: string;
  image: string;
}

export const BRANDS: BrandsType[] = [
  {
    icon: "icon-ampm",
    name: "ampm",
    image: "/images/home/brands/ampm.png",
  },
  {
    icon: "icon-damixa",
    name: "damixa",
    image: "/images/home/brands/damixa.png",
  },
]